import api from '../..'
import { ObjectToFormDataWithFiles, decamelizeThatDontBreaksFile } from '../../../helpers/converters.helper'

const setNotificationEmail = (data: any, courseId: string) => {
  const decamelizeData = decamelizeThatDontBreaksFile(data)
  const formData = ObjectToFormDataWithFiles(decamelizeData, 'course')
  return api.post(`administration/courses/${courseId}/notification_email`, formData, {
    headers: { 'content-type': 'multipart/form-data' },
  })
}

export default setNotificationEmail
